import router from '@/router/index';
import {
  WelcomeNavigation,
  ProviderNavigation,
  ResumeFsm
} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs } = api;
    let here = parent.active;

    here.init
      .to(here.provider);
    here.provider
      .to()
      .when(messageIs(ResumeFsm))
      .effect(
        ({context})=> {
          let specialty = context.rootState.login.provider.specialty;
          let id = context.rootState.login.provider.id;
          if (specialty && id) {
            router.push({
              name:ProviderNavigation, 
              params: {
                specialty,
                id
              }
            })
          } else {
            router.push({name: WelcomeNavigation})
          }

        }
      );
  }
};
